<p-dialog [resizable]="false"
  [(visible)]="visible"
  (onHide)="onHide()"
  [modal]="true"
  [appendTo]="'body'"
  [baseZIndex]="23000"
  [autoZIndex]="true"
  [style]="{width: '500px'}"
  [draggable]="false"
  [showHeader]="false"
  styleClass="weather-export-dialog">

  <div class="export-modal-content">
    <div class="export-header">
      <h2>{{ 'EXPORT_DATA' | translate }}</h2>
      <button type="button" class="close-button" (click)="onHide()">
        <i class="pi pi-times"></i>
      </button>
    </div>

    <div class="export-body">

      <div class="export-field">
        <label>{{ 'DATA_SOURCE' | translate }}</label>
        <div class="data-source-with-step">
          <msf-select
            [(model)]="selectedDataSource"
            [options]="exportDataSourceOptions"
            optionValue="id"
            [optionSubtitle]="'gridStepKey'"
            [showSelectedSubtitle]="false"
            [placeholder]="'SELECT_DATA_SOURCE' | translate"
            [width]="'160px'"
            translateBy="none"
          >
          </msf-select>
          <app-weather-data-source-grid-step [sourceId]="selectedDataSource" />
        </div>
      </div>

      <div class="export-field">
        <label>{{ 'Layer' | translate }}</label>
        <msf-select
          [(model)]="exportDataType"
          (modelChange)="exportDataTypeChange.emit($event)"
          [options]="exportDataTypeOptions"
          optionValue="value"
          [placeholder]="'SELECT_LAYER' | translate"
          [style]="{'width':'100%'}"
          translateBy="names"
        >
        </msf-select>
      </div>

      <div class="export-field">
        <label>{{ 'EXPORT_FORMAT' | translate }}</label>
        <msf-select
          [(model)]="exportFormat"
          (modelChange)="exportFormatChange.emit($event)"
          [options]="exportFormatOptions"
          optionLabel="label"
          optionValue="value"
          translateBy="none"
          [placeholder]="'SELECT_FORMAT' | translate"
          [style]="{'width':'100%'}">
        </msf-select>
      </div>
    </div>

    <div class="export-footer">
      <button pButton
        type="button"
        [label]="'DOWNLOAD' | translate"
        (click)="onSaveExport()"
        class="save-btn">
      </button>
      <button pButton
        type="button"
        [label]="'CLOSE' | translate"
        (click)="onHide()"
        class="cancel-btn">
      </button>
    </div>
  </div>
</p-dialog>
